import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(30, 30, 30, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 1200px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: var(--font-family-ibm_plex_sans);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-family: var(--font-family-ibm_plex_sans);
  
  &:hover {
    background-color: #f3f4f6;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 40px;
  font-weight: 700;
  color: #000;
  margin: 0 0 12px 0;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const ModalDescription = styled.p`
  font-size: 16px;
  color: #000;
  margin: 0 0 32px 0;
  line-height: 1.5;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const ModalContent = styled.div`
  display: flex;
  gap: 32px;
  border: 1px solid #2E2277;
  border-radius: 0px 0px 8px 8px;
  padding: 24px;
  margin-top: 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const RightSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const SchoolTag = styled.div`
  background-color:#2E2277;
  color: white;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
  font-family: var(--font-family-ibm_plex_sans);

`;

export const CustomPlanTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #000;
  margin: 0 0 8px 0;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const CustomPlanDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 24px 0;
  line-height: 1.4;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const RequestQuoteButton = styled.button`
  background-color: #2E2277;
  color: white;
  border: none;
  width: 100%;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-family: var(--font-family-ibm_plex_sans);
  
  &:hover:not(:disabled) {
    background-color:rgb(35, 25, 97);
  }

  &:disabled {
    background-color: rgb(35, 25, 97);
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const AllInclusiveBanner = styled.div`
  background-color: #2E2277;
  color: white;
  padding: 8px 16px;
  border-radius: 8px 8px 0 0;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #000;
  font-family: var(--font-family-ibm_plex_sans);
`;

export const CheckIcon = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 16px;
  font-family: var(--font-family-ibm_plex_sans);
`;
